import createDebug from 'debug';
const sanitizeArgument = (value) => {
    if (!value?.isAxiosError)
        return value;
    return {
        name: value.name,
        message: value.message,
        code: value.code,
        status: value.response?.status,
    };
};
const createDiagnostic = (scope, level) => {
    const output = createDebug(`${scope}:${level}`);
    return (...args) => {
        const sanitized = args.map(sanitizeArgument);
        output(sanitized[0], ...sanitized.slice(1));
    };
};
//                                                                           
export const createDiagnosticLogger = (scope) => Object.freeze({
    error: createDiagnostic(scope, 'error'),
    log: createDiagnostic(scope, 'log'),
    warn: createDiagnostic(scope, 'warn'),
});
